import clsx from 'clsx';

import {
  WorkflowStep,
  WorkflowStepFile,
  WorkflowVisualizationData,
} from './workflowVisualizationModel';
import { WorkflowVisualizationStep } from './WorkflowVisualizationStep';

import styles from './workflowVisualization.module.scss';

export type WorkflowVisualizationProps = WorkflowVisualizationData & {
  onStepClick?: (step: WorkflowStep) => void;
  onFileClick?: (file: WorkflowStepFile) => void;
  className?: string;
};

export function WorkflowVisualization({
  steps,
  className,
  onStepClick,
  onFileClick,
}: WorkflowVisualizationProps) {
  return (
    <div className={clsx(styles['root'], className)}>
      {steps.map((step, index) => {
        const successor =
          index + 1 < steps.length
            ? {
                isActive: steps
                  .slice(index + 1)
                  .some((s) => s.triggeredAt != null),
              }
            : undefined;
        return (
          <WorkflowVisualizationStep
            step={step}
            successor={successor}
            key={index}
            onStepClick={
              onStepClick != null ? () => onStepClick(step) : undefined
            }
            onFileClick={onFileClick}
          />
        );
      })}
    </div>
  );
}
